// extracted by mini-css-extract-plugin
export default {"Placeholder":"OutbrainAd-module__Placeholder__TXBXo"};